export const translations = {
  en: {
    nav: { services: "Services", beforeAfter: "Before / After", process: "Process", reviews: "Reviews", faq: "FAQ", contact: "Contact", book: "Book Now", brand: "Brand" },
    hero: {
      topLeft: "Cleveland, Ohio",
      topRight: "CSIA Certified — Est. 2026",
      lines: [
        [{ t: "Expert", i: true }, { t: " care" }],
        [{ t: "for your", i: true }, { t: " chimney." }],
      ],
      sub: "Emberline is a master chimney studio. Sweeping, restoration, masonry and waterproofing — crafted with the precision of art.",
      cta1: "Start your booking",
      cta2: "Explore services",
      scroll: "Scroll to discover",
      imageCaption: "Every hearth, treated as a masterpiece.",
      scenes: ["Masonry & roof work", "Every chimney, protected", "The hearth, reborn", "Fire, mastered"],
    },
    essence: "the essence of emberline",
    showcase: {
      back1: "the",
      back2: "craft.",
      title: [{ t: "we restore " }, { t: "what fire built.", i: true }],
      caption: "Full restoration — from flue to crown",
    },
    gallery: {
      kicker: "the gallery",
      lines: [
        [{ t: "your chimney " }, { t: "will forever", i: true }],
        [{ t: "be a " }, { t: "masterpiece.", i: true }],
      ],
      drag: "Drag to explore",
    },
    poem: {
      lines: ["Fire is the ultra-living element.", "It is intimate and it is universal.", "It lives in our heart. It lives in the sky."],
      author: "Gaston Bachelard",
    },
    chat: {
      title: "Ember — Assistant",
      status: "Online now",
      welcome: "Hi! I'm Ember, the Emberline virtual assistant. Ask me about our services, pricing or availability — I can even book your Friday or Saturday visit right here in the chat.",
      placeholder: "Type your message...",
      error: "Sorry, something went wrong. Please try again.",
      suggestions: ["What services do you offer?", "How much is a cleaning?", "Book me a visit"],
      bookedTitle: "Appointment booked",
      errSlotTaken: "That time was just taken — please pick another available time.",
      errInvalid: "I couldn't complete the booking — some details were missing or invalid. Let's try again.",
    },
    preloader: {
      lines: [
        [{ t: "where " }, { t: "your", i: true }, { t: " chimney" }],
        [{ t: "becomes " }, { t: "art.", i: true }],
      ],
    },
    deserve: {
      l1: [{ t: "your home's " }, { t: "hearth", i: true }],
      mid: "DESERVES TO",
      l2: [{ t: "last " }, { t: "forever.", i: true }],
    },
    triptych: [
      { label: "From worn," },
      { label: "to restored," },
      { label: "to protected." },
    ],
    cta: {
      kicker: "Your home deserves to be protected",
      lines: [
        [{ t: "we'd be " }, { t: "honored", i: true }],
        [{ t: "to " }, { t: "care", i: true }, { t: " for it." }],
      ],
      button: "Start your booking",
    },
    statement: {
      lines: [
        [{ t: "where", i: true }, { t: " craftsmanship" }],
        [{ t: "meets", i: true }, { t: " fire." }],
      ],
      body: "Your fireplace is used every winter, then forgotten. It deserves to be protected forever. Emberline blends advanced inspection technology with hand craftsmanship, so every brick, flue and crown is preserved with exceptional precision.",
      small: "100% certified craftsmanship",
    },
    bigQuote: {
      text: "A hearth is the heart of a home. We keep its fire safe, its stone strong, and its walls dry — forever.",
      author: "The Emberline Principle",
    },
    marquee: ["CHIMNEY SWEEP", "INSPECTION", "MASONRY REPAIR", "WATERPROOFING", "CAPS & CROWNS", "LINER INSTALLATION", "ANIMAL REMOVAL", "DRONE INSPECTION"],
    stats: {
      items: [
        { value: 12, suffix: "+", label: "Years of Experience" },
        { value: 300, suffix: "+", label: "5-Star Reviews" },
        { value: 1500, suffix: "+", label: "Chimneys Restored" },
        { value: 100, suffix: "%", label: "Satisfaction Guaranteed" },
      ],
      badges: ["CSIA Certified Technicians", "Licensed · Bonded · Insured", "Free Drone Inspections"],
    },
    services: {
      kicker: "What we master",
      lines: [
        [{ t: "every flame ", i: false }, { t: "deserves", i: true }],
        [{ t: "a ", i: false }, { t: "flawless", i: true }, { t: " path." }],
      ],
      items: [
        { title: "Chimney Sweep & Cleaning", desc: "Deep removal of soot, creosote and blockages for a safe, efficient fireplace all season long." },
        { title: "Inspection & Drone Scan", desc: "Comprehensive Level 1–3 inspections with free aerial drone imaging to detect hidden damage." },
        { title: "Chimney Repair & Rebuild", desc: "From crack repair to complete rebuilds — structural integrity restored by master masons." },
        { title: "Masonry & Tuckpointing", desc: "Precision brickwork restoration that brings back the beauty and strength of your chimney." },
        { title: "Waterproofing & Leak Sealing", desc: "Advanced water-repellent systems, flashing and crown sealing that stop leaks before they start." },
        { title: "Caps, Crowns & Liners", desc: "Custom caps, weather-resistant crowns and stainless liners protecting your home year-round." },
      ],
    },
    beforeAfter: {
      kicker: "The transformation",
      lines: [
        [{ t: "from ", i: false }, { t: "worn,", i: true }],
        [{ t: "to ", i: false }, { t: "reborn.", i: true }],
      ],
      sub: "Drag the slider and witness what master craftsmanship looks like. Same chimney — before and after our work.",
      before: "BEFORE",
      after: "AFTER",
      drag: "Drag to compare",
      cases: ["Full masonry restoration — Cleveland West Side", "Crown rebuild & waterproofing — Lakewood", "Complete sweep & liner install — Ohio City"],
    },
    process: {
      kicker: "How it works",
      lines: [
        [{ t: "a process ", i: false }, { t: "built", i: true }],
        [{ t: "for ", i: false }, { t: "perfection.", i: true }],
      ],
      steps: [
        { title: "Book Online", desc: "Choose your slot in seconds. Our calendar shows real-time availability — weekends fill up fast." },
        { title: "We Inspect", desc: "A certified technician performs a full diagnostic, including free drone imaging of your chimney." },
        { title: "We Perfect", desc: "Repairs, cleaning or waterproofing executed with premium materials and a satisfaction guarantee." },
      ],
    },
    testimonials: {
      kicker: "What clients say",
      lines: [
        [{ t: "trusted ", i: false }, { t: "by", i: true }],
        [{ t: "hundreds of ", i: false }, { t: "homes.", i: true }],
      ],
      items: [
        { name: "Sarah M.", area: "Lakewood, OH", text: "Absolutely stunning work. They rebuilt our crown and waterproofed everything — not a single leak since. The booking process was effortless." },
        { name: "James R.", area: "Cleveland, OH", text: "The drone inspection blew my mind. They found damage two other companies missed. Professional from start to finish." },
        { name: "Maria G.", area: "Parma, OH", text: "Booked a Saturday slot online, they arrived on time and left the fireplace looking brand new. Worth every penny." },
        { name: "David K.", area: "Rocky River, OH", text: "True craftsmen. The masonry restoration made our 1940s chimney look better than the original. Highly recommend." },
      ],
    },
    faq: {
      kicker: "Questions",
      lines: [
        [{ t: "everything ", i: false }, { t: "you", i: true }],
        [{ t: "need to ", i: false }, { t: "know.", i: true }],
      ],
      items: [
        { q: "How often should I have my chimney inspected and cleaned?", a: "At least once a year. Annual maintenance prevents creosote buildup — the #1 cause of chimney fires — and keeps your system safe and efficient." },
        { q: "What are the signs that my chimney needs repair?", a: "Visible cracks, white staining, water leaks, smoke backing up, or unusual odors. If you notice any of these, book an inspection immediately." },
        { q: "What exactly is chimney waterproofing?", a: "We apply professional-grade water repellent to the masonry, seal the crown and repair flashing — preventing water infiltration that destroys chimneys from the inside." },
        { q: "How long does a chimney sweep take?", a: "A standard sweep takes 45–60 minutes. Inspections with drone imaging add about 30 minutes." },
        { q: "Why are weekday appointments unavailable?", a: "Due to extremely high demand, our Monday–Thursday schedule is fully booked weeks in advance. Friday and Saturday slots are released weekly — book yours before they're gone." },
      ],
    },
    booking: {
      kicker: "Reserve your slot",
      lines: [
        [{ t: "book your", i: false }],
        [{ t: "appointment.", i: true }],
      ],
      sub: "Our weekday agenda is fully booked. A few Friday & Saturday slots remain — secure yours now.",
      demandBadge: "High demand — Mon–Thu fully booked",
      hint: "Your hearth, in master hands.",
      step1: "Pick a date",
      step2: "Pick a time",
      step3: "Your details",
      full: "Full",
      closed: "Closed",
      available: "Open",
      taken: "Taken",
      legend_full: "Fully booked",
      legend_open: "Available",
      name: "Full name",
      phone: "Phone",
      email: "Email",
      service: "Service needed",
      message: "Tell us about your chimney (optional)",
      submit: "Confirm Appointment",
      submitting: "Booking...",
      successTitle: "Appointment confirmed!",
      successText: "We'll contact you shortly to confirm the details. See you soon!",
      addCal: "Add it to your calendar",
      bookAnother: "Book another appointment",
      selectServicePlaceholder: "Select a service",
      services: ["Chimney Sweep & Cleaning", "Inspection & Drone Scan", "Chimney Repair", "Masonry & Tuckpointing", "Waterproofing", "Caps, Crowns & Liners", "Other"],
      errRequired: "Please fill in all required fields",
      errSlot: "That slot was just taken — please pick another",
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    footer: {
      tagline: "Master chimney care, crafted like art.",
      contactTitle: "Contact",
      hoursTitle: "Hours",
      hours1: "Friday — Saturday: 8:00 AM – 5:00 PM",
      hours2: "Monday — Thursday: Fully booked",
      linksTitle: "Explore",
      address: "12501 Lorain Ave, Cleveland, OH 44111",
      rights: "All rights reserved.",
    },
    brand: {
      kicker: "Brand Identity",
      lines: [
        [{ t: "the ", i: false }, { t: "name.", i: true }],
        [{ t: "the ", i: false }, { t: "mark.", i: true }],
      ],
      sub: "10 professional name candidates and 8 exclusive AI-crafted 4K logo concepts.",
      winner: "SELECTED",
      namesTitle: "Company name candidates",
      finalTitle: "The official logo",
      logosTitle: "Logo concepts — 4K",
      logoHint: "Right-click any logo to save it in full resolution.",
      names: [
        { name: "Emberline Chimney Co.", why: "Ember + Line: fire mastery meets precision. Modern, memorable, ownable." },
        { name: "Vulcan Flue & Masonry", why: "The Roman god of fire — power and tradition." },
        { name: "HearthGuard Pro", why: "Protection-focused, instantly communicates trust." },
        { name: "PyraCore Chimney Systems", why: "Technical and futuristic, engineering-driven." },
        { name: "Solstice Sweep & Seal", why: "Elegant alliteration covering cleaning + waterproofing." },
        { name: "FlareStack Chimney Pros", why: "Industrial edge with a bold, energetic tone." },
        { name: "Titan Hearth Co.", why: "Strength and scale — a premium heavyweight feel." },
        { name: "EmberForge Chimney & Masonry", why: "Craftsmanship forged in fire." },
        { name: "Apex Flue Solutions", why: "Peak performance positioning, corporate and clean." },
        { name: "IgnisShield Chimney Care", why: "Latin 'ignis' (fire) + shield: protection with class." },
      ],
    },
    admin: {
      title: "Reservations Panel",
      sub: "All appointments booked through the website",
      refresh: "Refresh",
      logout: "Log out",
      lockTitle: "Restricted access",
      lockSub: "Enter the access code to view the reservations panel.",
      passPlaceholder: "Access code",
      enter: "Enter",
      wrong: "Invalid passcode",
      empty: "No appointments yet.",
      cols: { client: "Client", contact: "Contact", service: "Service", when: "Date & Time", status: "Status", actions: "" },
      statuses: { pending: "Pending", confirmed: "Confirmed", completed: "Completed", cancelled: "Cancelled" },
    },
  },
  es: {
    nav: { services: "Servicios", beforeAfter: "Antes / Después", process: "Proceso", reviews: "Reseñas", faq: "Preguntas", contact: "Contacto", book: "Reservar", brand: "Marca" },
    hero: {
      topLeft: "Cleveland, Ohio",
      topRight: "Certificados CSIA — Est. 2026",
      lines: [
        [{ t: "Cuidado", i: true }, { t: " experto" }],
        [{ t: "para tu", i: true }, { t: " chimenea." }],
      ],
      sub: "Emberline es un estudio maestro de chimeneas. Limpieza, restauración, mampostería e impermeabilización — con la precisión del arte.",
      cta1: "Comienza tu reserva",
      cta2: "Ver servicios",
      scroll: "Desliza para descubrir",
      imageCaption: "Cada hogar, tratado como una obra maestra.",
      scenes: ["Trabajo en el techo", "Cada chimenea, protegida", "El hogar, renacido", "El fuego, dominado"],
    },
    essence: "la esencia de emberline",
    showcase: {
      back1: "el",
      back2: "oficio.",
      title: [{ t: "restauramos " }, { t: "lo que el fuego construyó.", i: true }],
      caption: "Restauración completa — del conducto a la corona",
    },
    gallery: {
      kicker: "la galería",
      lines: [
        [{ t: "tu chimenea " }, { t: "será por siempre", i: true }],
        [{ t: "una " }, { t: "obra maestra.", i: true }],
      ],
      drag: "Arrastra para explorar",
    },
    poem: {
      lines: ["El fuego es lo ultra-vivo.", "Es íntimo y es universal.", "Vive en nuestro corazón. Vive en el cielo."],
      author: "Gaston Bachelard",
    },
    chat: {
      title: "Ember — Asistente",
      status: "En línea",
      welcome: "¡Hola! Soy Ember, el asistente virtual de Emberline. Pregúntame por servicios, precios o disponibilidad — y puedo agendarte tu cita de viernes o sábado aquí mismo en el chat.",
      placeholder: "Escribe tu mensaje...",
      error: "Lo siento, algo salió mal. Inténtalo de nuevo.",
      suggestions: ["¿Qué servicios ofrecen?", "¿Cuánto cuesta una limpieza?", "Agéndame una visita"],
      bookedTitle: "Cita agendada",
      errSlotTaken: "Esa hora acaba de ocuparse — elige otra hora disponible, por favor.",
      errInvalid: "No pude completar la reserva — faltaron datos o eran inválidos. Intentemos de nuevo.",
    },
    preloader: {
      lines: [
        [{ t: "donde " }, { t: "tu", i: true }, { t: " chimenea" }],
        [{ t: "se vuelve " }, { t: "arte.", i: true }],
      ],
    },
    deserve: {
      l1: [{ t: "la " }, { t: "chimenea", i: true }, { t: " de tu hogar" }],
      mid: "MERECE",
      l2: [{ t: "perdurar " }, { t: "para siempre.", i: true }],
    },
    triptych: [
      { label: "De gastada," },
      { label: "a restaurada," },
      { label: "a protegida." },
    ],
    cta: {
      kicker: "Tu hogar merece estar protegido",
      lines: [
        [{ t: "sería un " }, { t: "honor", i: true }],
        [{ t: "cuidarlo ", i: false }, { t: "contigo.", i: true }],
      ],
      button: "Comienza tu reserva",
    },
    statement: {
      lines: [
        [{ t: "donde", i: true }, { t: " la artesanía" }],
        [{ t: "se une", i: true }, { t: " al fuego." }],
      ],
      body: "Tu chimenea se usa cada invierno y luego se olvida. Merece estar protegida para siempre. Emberline combina tecnología avanzada de inspección con artesanía a mano, para que cada ladrillo, conducto y corona se preserve con precisión excepcional.",
      small: "100% artesanía certificada",
    },
    bigQuote: {
      text: "El hogar es el corazón de la casa. Mantenemos su fuego seguro, su piedra fuerte y sus muros secos — para siempre.",
      author: "El Principio Emberline",
    },
    marquee: ["LIMPIEZA DE CHIMENEAS", "INSPECCIÓN", "MAMPOSTERÍA", "IMPERMEABILIZACIÓN", "TAPAS Y CORONAS", "INSTALACIÓN DE LINERS", "REMOCIÓN DE ANIMALES", "INSPECCIÓN CON DRON"],
    stats: {
      items: [
        { value: 12, suffix: "+", label: "Años de Experiencia" },
        { value: 300, suffix: "+", label: "Reseñas de 5 Estrellas" },
        { value: 1500, suffix: "+", label: "Chimeneas Restauradas" },
        { value: 100, suffix: "%", label: "Satisfacción Garantizada" },
      ],
      badges: ["Técnicos Certificados CSIA", "Licencia · Fianza · Seguro", "Inspección con Dron Gratis"],
    },
    services: {
      kicker: "Lo que dominamos",
      lines: [
        [{ t: "cada llama ", i: false }, { t: "merece", i: true }],
        [{ t: "un camino ", i: false }, { t: "impecable.", i: true }],
      ],
      items: [
        { title: "Limpieza y Barrido de Chimenea", desc: "Eliminación profunda de hollín, creosota y obstrucciones para un hogar seguro y eficiente." },
        { title: "Inspección y Escaneo con Dron", desc: "Inspecciones completas nivel 1–3 con imágenes aéreas gratuitas para detectar daños ocultos." },
        { title: "Reparación y Reconstrucción", desc: "Desde grietas hasta reconstrucciones completas — integridad estructural restaurada por maestros." },
        { title: "Mampostería y Tuckpointing", desc: "Restauración de ladrillo con precisión que devuelve la belleza y fuerza a tu chimenea." },
        { title: "Impermeabilización y Sellado", desc: "Sistemas repelentes de agua, flashing y sellado de corona que detienen filtraciones antes de que empiecen." },
        { title: "Tapas, Coronas y Liners", desc: "Tapas a medida, coronas resistentes al clima y liners de acero que protegen tu hogar todo el año." },
      ],
    },
    beforeAfter: {
      kicker: "La transformación",
      lines: [
        [{ t: "de ", i: false }, { t: "gastado,", i: true }],
        [{ t: "a ", i: false }, { t: "renacido.", i: true }],
      ],
      sub: "Arrastra el control y mira lo que logra la verdadera maestría. La misma chimenea — antes y después de nuestro trabajo.",
      before: "ANTES",
      after: "DESPUÉS",
      drag: "Arrastra para comparar",
      cases: ["Restauración total de mampostería — Cleveland West Side", "Reconstrucción de corona e impermeabilización — Lakewood", "Limpieza completa e instalación de liner — Ohio City"],
    },
    process: {
      kicker: "Cómo funciona",
      lines: [
        [{ t: "un proceso ", i: false }, { t: "hecho", i: true }],
        [{ t: "para la ", i: false }, { t: "perfección.", i: true }],
      ],
      steps: [
        { title: "Reserva Online", desc: "Elige tu horario en segundos. Nuestro calendario muestra disponibilidad real — los fines de semana se agotan rápido." },
        { title: "Inspeccionamos", desc: "Un técnico certificado realiza un diagnóstico completo, incluyendo imágenes con dron gratis." },
        { title: "Perfeccionamos", desc: "Reparaciones, limpieza o impermeabilización con materiales premium y garantía de satisfacción." },
      ],
    },
    testimonials: {
      kicker: "Lo que dicen los clientes",
      lines: [
        [{ t: "la confianza ", i: false }, { t: "de", i: true }],
        [{ t: "cientos de ", i: false }, { t: "hogares.", i: true }],
      ],
      items: [
        { name: "Sarah M.", area: "Lakewood, OH", text: "Un trabajo impresionante. Reconstruyeron la corona e impermeabilizaron todo — ni una sola filtración desde entonces. Reservar fue facilísimo." },
        { name: "James R.", area: "Cleveland, OH", text: "La inspección con dron me voló la cabeza. Encontraron daños que otras dos compañías pasaron por alto. Profesionales de principio a fin." },
        { name: "Maria G.", area: "Parma, OH", text: "Reservé un sábado online, llegaron puntuales y dejaron la chimenea como nueva. Vale cada centavo." },
        { name: "David K.", area: "Rocky River, OH", text: "Verdaderos artesanos. La restauración dejó nuestra chimenea de 1940 mejor que la original. Muy recomendados." },
      ],
    },
    faq: {
      kicker: "Preguntas",
      lines: [
        [{ t: "todo lo ", i: false }, { t: "que", i: true }],
        [{ t: "necesitas ", i: false }, { t: "saber.", i: true }],
      ],
      items: [
        { q: "¿Con qué frecuencia debo inspeccionar y limpiar mi chimenea?", a: "Al menos una vez al año. El mantenimiento anual previene la acumulación de creosota — la causa #1 de incendios de chimenea." },
        { q: "¿Cuáles son las señales de que mi chimenea necesita reparación?", a: "Grietas visibles, manchas blancas, filtraciones de agua, humo que regresa u olores extraños. Si notas alguna, reserva una inspección de inmediato." },
        { q: "¿Qué es exactamente la impermeabilización de chimeneas?", a: "Aplicamos repelente de agua profesional a la mampostería, sellamos la corona y reparamos el flashing — evitando filtraciones que destruyen la chimenea desde adentro." },
        { q: "¿Cuánto tarda una limpieza de chimenea?", a: "Una limpieza estándar toma de 45 a 60 minutos. Las inspecciones con dron agregan unos 30 minutos." },
        { q: "¿Por qué no hay citas entre semana?", a: "Debido a la altísima demanda, nuestra agenda de lunes a jueves está completamente llena con semanas de anticipación. Los viernes y sábados se liberan cupos cada semana — asegura el tuyo antes de que se agoten." },
      ],
    },
    booking: {
      kicker: "Reserva tu cupo",
      lines: [
        [{ t: "agenda tu", i: false }],
        [{ t: "cita.", i: true }],
      ],
      sub: "Nuestra agenda entre semana está llena. Quedan pocos cupos de viernes y sábado — asegura el tuyo ahora.",
      demandBadge: "Alta demanda — Lun a Jue agenda completa",
      hint: "Tu hogar, en manos maestras.",
      step1: "Elige el día",
      step2: "Elige la hora",
      step3: "Tus datos",
      full: "Lleno",
      closed: "Cerrado",
      available: "Libre",
      taken: "Ocupado",
      legend_full: "Agenda completa",
      legend_open: "Disponible",
      name: "Nombre completo",
      phone: "Teléfono",
      email: "Correo electrónico",
      service: "Servicio que necesitas",
      message: "Cuéntanos sobre tu chimenea (opcional)",
      submit: "Confirmar Cita",
      submitting: "Reservando...",
      successTitle: "¡Cita confirmada!",
      successText: "Te contactaremos pronto para confirmar los detalles. ¡Nos vemos!",
      addCal: "Agrégala a tu calendario",
      bookAnother: "Reservar otra cita",
      selectServicePlaceholder: "Selecciona un servicio",
      services: ["Limpieza de Chimenea", "Inspección y Escaneo con Dron", "Reparación de Chimenea", "Mampostería y Tuckpointing", "Impermeabilización", "Tapas, Coronas y Liners", "Otro"],
      errRequired: "Por favor completa todos los campos requeridos",
      errSlot: "Ese horario acaba de ocuparse — elige otro",
      months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      days: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
    },
    footer: {
      tagline: "Cuidado maestro de chimeneas, hecho como arte.",
      contactTitle: "Contacto",
      hoursTitle: "Horario",
      hours1: "Viernes — Sábado: 8:00 AM – 5:00 PM",
      hours2: "Lunes — Jueves: Agenda completa",
      linksTitle: "Explora",
      address: "12501 Lorain Ave, Cleveland, OH 44111",
      rights: "Todos los derechos reservados.",
    },
    brand: {
      kicker: "Identidad de Marca",
      lines: [
        [{ t: "el ", i: false }, { t: "nombre.", i: true }],
        [{ t: "la ", i: false }, { t: "marca.", i: true }],
      ],
      sub: "10 nombres profesionales candidatos y 8 conceptos de logo exclusivos en 4K creados con IA.",
      winner: "ELEGIDO",
      namesTitle: "Nombres candidatos",
      finalTitle: "El logo oficial",
      logosTitle: "Conceptos de logo — 4K",
      logoHint: "Haz clic derecho en cualquier logo para guardarlo en máxima resolución.",
      names: [
        { name: "Emberline Chimney Co.", why: "Ember + Line: dominio del fuego y precisión. Moderno, memorable y único." },
        { name: "Vulcan Flue & Masonry", why: "El dios romano del fuego — poder y tradición." },
        { name: "HearthGuard Pro", why: "Enfocado en protección, comunica confianza al instante." },
        { name: "PyraCore Chimney Systems", why: "Técnico y futurista, con ADN de ingeniería." },
        { name: "Solstice Sweep & Seal", why: "Aliteración elegante que cubre limpieza + impermeabilización." },
        { name: "FlareStack Chimney Pros", why: "Toque industrial con tono audaz y enérgico." },
        { name: "Titan Hearth Co.", why: "Fuerza y escala — sensación premium de peso pesado." },
        { name: "EmberForge Chimney & Masonry", why: "Artesanía forjada en fuego." },
        { name: "Apex Flue Solutions", why: "Posicionamiento de máximo rendimiento, corporativo y limpio." },
        { name: "IgnisShield Chimney Care", why: "'Ignis' (fuego en latín) + escudo: protección con clase." },
      ],
    },
    admin: {
      title: "Panel de Reservas",
      sub: "Todas las citas reservadas desde la página web",
      refresh: "Actualizar",
      logout: "Salir",
      lockTitle: "Acceso restringido",
      lockSub: "Ingresa el código de acceso para ver el panel de reservas.",
      passPlaceholder: "Código de acceso",
      enter: "Entrar",
      wrong: "Código incorrecto",
      empty: "Aún no hay citas.",
      cols: { client: "Cliente", contact: "Contacto", service: "Servicio", when: "Fecha y Hora", status: "Estado", actions: "" },
      statuses: { pending: "Pendiente", confirmed: "Confirmada", completed: "Completada", cancelled: "Cancelada" },
    },
  },
};
